export default {
  listTab: {
    newsAggregators: 'Tin Tổng Hợp',
    autoNews: 'Tin Tự Động',
    premiumAnalysis: 'Nhật ký FiinTrade',
    expertView: 'FiinTrade Call',
  },
  exportViewTime: {
    mostRecent: 'Gần Đây',
    mostPopular: 'Phổ biến',
    contributors: 'Đóng góp',
    favorite: 'Yêu thích',
  },
  listTitleTable: {
    TICKER: 'MÃ',
    NEWS: 'TIÊU ĐỀ',
    SOURCE: 'NGUỒN TIN',
    TIME: 'GIỜ', // hh:mm
    CONTRIBUTOR: 'ĐÓNG GÓP',
    FAVORITE: 'YÊU THÍCH',
    RUMORS: 'TIN ĐỒN',
    TRUSTABILITY: 'ĐỘ TIN CẬY',
    TYPE: 'LOẠI',
  },
  Trustability: 'Độ tin cậy',
  listTrustability: {
    low: 'Thấp',
    medium: 'Trung bình',
    high: 'Cao',
  },
  filterTime: {
    from: 'Từ',
    to: 'đến',
  },
  date: 'Ngày',
};
